const home = () => {
    var slider_testimonials = $('#testimonials-slider');

    if( slider_testimonials.length > 0 ){

        slider_testimonials.on('init', function(event, slick, direction){
            $(this).addClass('show')
        });

        slider_testimonials.slick({
            infinite: false,
            centerMode: false,
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            autoplay: true,
            autoplaySpeed: 2500,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ],
        });

        var timerTestimonials = 0;

        function showTestimonials(elem, timer){
            $("#" + elem).find('.slick-slide').find(".item").each(function(){
                var that = $(this);

                setTimeout(function(){
                    $(that).toggleClass("show")
                },timer);

                timer = timer + 125;
            })
        }

        new Waypoint({
            element: document.getElementById('testimonials-section'),
            handler: function(direction) {
                showTestimonials('testimonials-slider', timerTestimonials)
            },
            offset: '60%'
        });
    }

    var slider_features = $('#features-list');

    if( slider_features.length > 0 ){

        slider_features.on('init', function(event, slick, direction){
            $(this).addClass('show')
        });

        slider_features.slick({
            infinite: true,
            centerMode: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            autoplay: true,
            autoplaySpeed: 4000,
            pauseOnHover: true,
            responsive: [
                {
                    breakpoint: 1600,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ],
        });
        
        var timerFeatures = 0;

        function showFeaturesItems(elem, timer){
            $("#" + elem).find('.item').find('img').each(function(){
                var that = $(this);

                setTimeout(function(){
                    $(that).toggleClass("bounceIn animated")
                },timer);

                timer = timer + 125;
            })
        }

        new Waypoint({
            element: document.getElementById('features-section'),
            handler: function(direction) {
                showFeaturesItems('features-list', timerFeatures)
            },
            offset: '60%'
        });
    }

    var timerHowItWorks = 0;

    function showHowItWorksItems(elem, timer){
        $("#" + elem).find('li').each(function(){
            var that = $(this);

            setTimeout(function(){
                $(that).toggleClass("bounceIn animated");
            },timer);

            timer = timer + 125;
        })
    }
    
    if ($("#how-it-works-section").length) {
        new Waypoint({
            element: document.getElementById('how-it-works-section'),
            handler: function(direction) {
                showHowItWorksItems('how-it-works-list', timerHowItWorks);
            },
            offset: '60%'
        });
    }
    
    var timerStats = 0;

    function showStatsItems(elem, timer){
        $("#" + elem).find('li').each(function(){
            var that = $(this);

            setTimeout(function(){
                $(that).toggleClass("bounceIn animated");
            },timer);

            timer = timer + 125;
        })
    }
    
    var timerCounters = 0;
    var counted = false;
    var options = {
        useEasing: true,
        useGrouping: true,
        separator: '',
        decimal: ',',
    };

    function runCounters(elem, timer){
        $("#" + elem).find('.number').each(function(index){
            var that = $(this);
            var endVal = that.attr("count-val");

            setTimeout(function(){
                var numAnim = new CountUp("counter-"+index, 0, endVal, 0, 2, options);
                if (!numAnim.error) {
                    numAnim.start(function() {
                        if (index > 0) {
                            $(that).next().addClass('show');
                        }
                    });
                } else {
                    console.error(numAnim.error);
                }
            },timer);

            timer = timer + 125;
        });

        counted = true;
    }
    
    if ($("#partners-section").length) {
        new Waypoint({
            element: document.getElementById('partners-section'),
            handler: function(direction) {
                showStatsItems('stats-list', timerStats);
                if(!counted){
                    runCounters('stats-list', timerCounters);
                }
            },
            offset: '60%'
        });
    }

    if ($("#home-top").length) {
        new Waypoint({
            element: document.getElementById('home-top'),
            handler: function(direction) {
                if (window.innerWidth >= 768) {
                    $(".navigation").toggleClass("scroll");
                    $(".home-top").toggleClass("scroll");
                }
            },
            offset: '-10%'
        });
    }

    $(".features .item").click(function(e){
        e.preventDefault();
        $(this).toggleClass('clicked');
    });

    setTimeout(function(){
        var timerFeaturesItem = 0;
        $(".features .item").each(function(){
            var that = $(this);

            setTimeout(function(){
                $(that).toggleClass('show');
            },timerFeaturesItem);

            timerFeaturesItem = timerFeaturesItem + 125;
        })
    }, 1000);
    
    function getVideoId(url) {
        var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
        var match = url.match(regExp);

        if (match && match[2].length == 11) {
            return match[2];
        } else {
            return 'error';
        }
    }
    
    $('.video-box').each(function(){
        var url = $(this).attr('video-url');
        
        if (url != ""){
            var videoId = getVideoId(url);
            
            if (videoId != "error") {
                var iframeMarkup = '<iframe loading="lazy" width="560" height="315" src="//www.youtube.com/embed/' + videoId + '" frameborder="0" allowfullscreen></iframe>';
                $(this).append(iframeMarkup);
            }
        }
    });
    
    var slider_partners = $('#partners-slider');

    if( slider_partners.length > 0 ){

        slider_partners.on('init', function(event, slick, direction){
            $(this).addClass('show')
        });

        slider_partners.slick({
            infinite: true,
            centerMode: false,
            slidesToShow: 7,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            autoplay: false,
            autoplaySpeed: 3500,
            responsive: [
                {
                    breakpoint: 1600,
                    settings: {
                        slidesToShow: 7,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 5,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 400,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                }
            ],
        });

        var timerPartners = 0;

        function showPartners(elem, timer){
            $("#" + elem).find('.slick-slide').find(".item").each(function(){
                var that = $(this);

                setTimeout(function(){
                    $(that).toggleClass("show")
                },timer);

                timer = timer + 125;
            })
        }

        new Waypoint({
            element: document.getElementById('partners-section'),
            handler: function(direction) {
                // showPartners('partners-slider', timerPartners)
            },
            offset: '60%'
        });
    }
    
    var timerCabineSection = 0;

    function showCabineSectionItems(elem, timer){
        $("#" + elem).find('.cabine-features ul').each(function(){
            var list = $(this);
            
            $(list).find('li').each(function(){
                var item = $(this);
                
                setTimeout(function(){
                    $(item).toggleClass("show")
                },timer);

                timer = timer + 125;
            });

        })
    }

    if ($("#cabine-section").length) {
        new Waypoint({
            element: document.getElementById('cabine-section'),
            handler: function(direction) {
                showCabineSectionItems('cabine-section', timerCabineSection);
            },
            offset: '60%'
        });
    }
    
    $("#content-section .nav li").click(function(e){
        e.preventDefault();
        $("#content-section .nav li").removeClass('active');
        $(this).toggleClass('active');
    });
    
    var timerPros = 0;

    function showProsItems(elem, timer){
        $("#pros-section .left img").toggleClass("bounceIn animated");
                
        setTimeout(function(){
            $("." + elem).find('li').each(function(){
                var that = $(this);

                setTimeout(function(){
                    $(that).toggleClass("show");
                },timer);

                timer = timer + 150;
            })
        }, 250);
    }
    
    if ($("#pros-section").length) {
        new Waypoint({
            element: document.getElementById('pros-section'),
            handler: function(direction) {
                showProsItems('pros-list', timerPros);
            },
            offset: '60%'
        });
    }
    
 }

 module.exports = {
    home,
 };